import Experience from "./Experience";

function Resume() {
  return (
    <div className="">
      <div class="container px-5 my-5">
        <div class="text-center mb-5">
          <h1 class="display-5 fw-bolder mb-0">
            <span class="text-gradient d-inline">Resume</span>
          </h1>
        </div>

        <div class="row gx-5 justify-content-center mt-5">
          <div class="col-lg-11 col-xl-9 col-xxl-8">
            <section>
              <div class="d-flex align-items-center justify-content-between mb-4">
                <h2 class="text-primary fw-bolder mb-0">Experience</h2>
                <a
                  class="btn btn-primary px-4 py-3"
                  href="/fmujtahids.pdf"
                  download="fmujtahids.pdf"
                >
                  <div class="d-inline-block bi bi-download me-2"></div>
                  Download Resume
                </a>
              </div>
              <Experience />
            </section>
            <hr />
            <section>
              <h2 class="text-secondary fw-bolder mb-4">Education</h2>

              <div class="card shadow border-0 rounded-4 mb-5">
                <div class="card-body p-5">
                  <div class="row align-items-center gx-5">
                    <div class="col text-center text-lg-start mb-4 mb-lg-0">
                      <div class="bg-light p-4 rounded-4">
                        <div class="text-secondary fw-bolder mb-2">
                          2023 - 2025
                        </div>
                        <div class="mb-2">
                          <div class="small fw-bolder">
                            {" "}
                            Campbellsville University
                          </div>
                          <div class="small text-muted">Los Angeles, CA</div>
                        </div>
                        <div class="fst-italic">
                          <div class="small text-muted">Master's</div>
                          <div class="small text-muted">
                            {" "}
                            Computer Science & Engineering
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-8">
                      <div>
                        During my Master of Computer Applications, I
                        strengthened my expertise in full-stack development with
                        a strong emphasis on C#, ASP.NET Core MVC, Web APIs, and
                        scalable backend architecture. The program allowed me to
                        dive deeper into enterprise application development,
                        database optimization using SQL Server and PostgreSQL,
                        and modern frontend practices with frameworks like
                        Angular and React. I also improved my understanding of
                        system design, software architecture, and API-driven
                        workflows.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card shadow border-0 rounded-4 mb-5">
                <div class="card-body p-5">
                  <div class="row align-items-center gx-5">
                    <div class="col text-center text-lg-start mb-4 mb-lg-0">
                      <div class="bg-light p-4 rounded-4">
                        <div class="text-secondary fw-bolder mb-2">
                          2015 - 2019
                        </div>
                        <div class="mb-2">
                          <div class="small fw-bolder">
                            {" "}
                            Jawaharlal Nehru Technological University
                          </div>
                          <div class="small text-muted">Hyderabad India</div>
                        </div>
                        <div class="fst-italic">
                          <div class="small text-muted">Bachelor's</div>
                          <div class="small text-muted">
                            {" "}
                            Computer Science & Engineering
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-8">
                      <div>
                        During my B.Tech at Jawaharlal Nehru Technological
                        University, I built a strong foundation in core computer
                        science concepts such as algorithms, data structures,
                        operating systems, databases, and object-oriented
                        programming. I learned how software systems are
                        designed, developed, and optimized, and gained hands-on
                        experience working with programming languages, web
                        technologies, and database management.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div class="pb-5"></div>
            <section>
              <div class="card shadow border-0 rounded-4 mb-5">
                <div class="card-body p-5">
                  <div class="mb-5">
                    <div class="d-flex align-items-center mb-4">
                      <div class="feature bg-primary bg-gradient-primary-to-secondary text-white rounded-3 me-3">
                        <i class="bi bi-tools"></i>
                      </div>
                      <h3 class="fw-bolder mb-0">
                        <span class="text-gradient d-inline">
                          Top Professional Skills
                        </span>
                      </h3>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3 mb-4">
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          .NET / ASP.NET
                        </div>
                      </div>
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Minimal Api
                        </div>
                      </div>
                      <div class="col">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Entity Framework
                        </div>
                      </div>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          React Js
                        </div>
                      </div>
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Azure (CI/CD Pipelines)
                        </div>
                      </div>
                      <div class="col">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Ui / Ux Design (Figma)
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-0">
                    <div class="d-flex align-items-center mb-4">
                      <div class="feature bg-primary bg-gradient-primary-to-secondary text-white rounded-3 me-3">
                        <i class="bi bi-code-slash"></i>
                      </div>
                      <h3 class="fw-bolder mb-0">
                        <span class="text-gradient d-inline">Languages</span>
                      </h3>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3 mb-4">
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          C#
                        </div>
                      </div>
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Visual Basics
                        </div>
                      </div>
                      <div class="col">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          JavaScript
                        </div>
                      </div>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Typescript
                        </div>
                      </div>
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          SQL Server
                        </div>
                      </div>
                      <div class="col">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          HTML / CSS
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Resume;
